import { ActionButton } from '@adobe/react-spectrum';
import React from 'react';
import { getAnalytics, logEvent } from 'firebase/analytics';
import User from '@spectrum-icons/workflow/User';

export function BreadCrumbAuthorLinkButtons(props) {
    let label = 'Profile';
    if (props.source && props.source !== '') {
        label = `${props.source.substring(0, 1).toUpperCase()}${props.source
            .substring(1)
            .toLowerCase()} profile`;
    }

    return (
        <ActionButton
            isDisabled={props?.isDisabled}
            aria-label={label}
            onPress={() => {
                logEvent(getAnalytics(), 'preview_open_author', { url: props.url });
                window.open(props.url, `_blank`);
            }}
        >
            <span className="bcBtnLabel">{label}</span>
            <User />
        </ActionButton>
    );
}
